import React, { useMemo } from 'react';
import { setAndGetAttributes } from '../FormInputFields/FormInputFunctions';
import Wrp from '../../hoc/Wrp/Wrp';
import { Select2 } from 'select2-react-component';
import { isSet } from '../../Utils/CommonFunctions';

/** CRM picklist payloads often arrive as { name, value } — selects need a primitive. */
export const unwrapPagesPicklistValue = (raw) => {
  if (raw == null || Array.isArray(raw)) return raw;
  if (typeof raw === 'object') {
    if (raw.value != null && raw.value !== '') return raw.value;
    if (raw.name != null && raw.name !== '') return raw.name;
    if (raw.label != null && raw.label !== '') return raw.label;
    return '';
  }
  return raw;
};

const PagesPickList = (props) => {
  const { isDefault, required, options } = props;
  const value = unwrapPagesPicklistValue(props.value);
  const displayType = isSet(props.displaytype, props.displayType);
  const isTabs = displayType === 'Tabs';
  let attr = setAndGetAttributes(props);

  const fieldOnChangeHandler = (val) => {
    const { changeHandler } = props;
    // console.log('val',val);
    changeHandler(val);
  };
// console.log('options',options);
  const selectOptionsState = useMemo(() => {
    let selectOptions = [{ label: '-None-', value: '' }];
    try {
      selectOptions = options.map((item) => ({
        label: item.label || item.value,
        name: item.label || item.value,
        value: item.value,
      }));
    } catch (e) {}
    return selectOptions;
  }, [options]);

  if (isTabs) {
    let tabClass = 'nav nav-pills navcrm-primary nav-pills-no-bd p-2 pl-2';
    let tabListClass = 'nav-item submenu';
    let tabAnchorClass = 'nav-link';
    try {
      tabClass = isSet(props.tabclass, tabClass);
      tabListClass = isSet(props.tablistclass, tabListClass);
      tabAnchorClass = isSet(props.tabanchorclass, tabAnchorClass);
    } catch (e) {}

    return (
      <Wrp>
        <ul className={tabClass}>
          {selectOptionsState.map((itm, itmIndex) => {
            if (itm.value === '') {
              return null;
            }
            const isSelected =
              itm.value === value || itm.label === value ? 'active show' : '';
            return (
              <li
                className={tabListClass}
                key={itmIndex}
                onClick={() => fieldOnChangeHandler(itm.value)}
              >
                <a
                  className={`${tabAnchorClass} ${isSelected}`}
                  href="#"
                  onClick={(e) => e.preventDefault()}
                  aria-expanded="true"
                >
                  {itm.label}
                </a>
              </li>
            );
          })}
        </ul>
      </Wrp>
    );
  }

  return (
    <Wrp>
      {(isDefault === true || props?.isdefault === true || props?.isdefault === "true") ? (
        <select
          {...attr}
          value={value}
          onChange={(e) => fieldOnChangeHandler(e.target.value)}
          style={attr.style}
        >
          {selectOptionsState.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.name}
            </option>
          ))}
        </select>
      ) : (
        <div className={required === true ? 'mandatory select2-arrow' : 'select2-arrow'} style={attr.style}>
          <Select2
            data={selectOptionsState}
            {...attr}
            minCountForSearch={1}
            value={value}
            update={(val) => fieldOnChangeHandler(val)}
          />
        </div>
      )}
    </Wrp>
  );
};

PagesPickList.defaultProps = {
  isMandatory: false,
  isDefault: false,
  isNoneAllowed: true,
  required: false,
  className: 'form-control',
};

export default PagesPickList;


